import { PlanNamesType } from "@hz/stealthy-gmc-cloaker-common/constants";
import { api, Tags } from "../..";
import {CreateCheckoutSessionParams, UpgradePlanParams} from "@hz/stealthy-gmc-cloaker-common/api-types/checkout"


export interface HasActiveSubscriptionResponse {
  hasActiveSubscription: boolean;
}

export interface HasActiveSubscriptionParams {
  mondayAccountId: string;
}

const subscriptionRequestsSlice = api.injectEndpoints({
  endpoints: (build) => ({
    startCheckout: build.mutation<{url: string}, CreateCheckoutSessionParams>({
      query: ({ plan }) => ({
        url: `/checkout`,
        body: {
          plan 
        },
        method: "POST",
      }),
    }),
    upgradePlan: build.mutation<{success: boolean}, UpgradePlanParams>({
      query: ({newPlan}) => ({
        url: `/checkout/upgrade`,
        body: {
          newPlan
        },
        method: "POST",
      }),
    
      
    }),


    // checkSubscription: build.query<HasActiveSubscriptionResponse, HasActiveSubscriptionParams>({
    //   query: ({ mondayAccountId }) => ({
    //     url: `subscription-status?mondayAccountId=${mondayAccountId}`,
    //     headers: {
    //       "Content-Type": "application/json",
    //       "ngrok-skip-browser-warning": "skip-browser-warning",
    //     },
    //     method: "GET",
    //   }),
    // }),
  }),
});

export default subscriptionRequestsSlice;
